/* eslint-disable import/no-internal-modules */
import { AccountPanelMobileV3 } from "user_site/features/account";
import { WithProviders } from "user_site/utils";

const Component = () => (
  <WithProviders>
    <AccountPanelMobileV3 />
  </WithProviders>
);

export default Component;
